import { Link } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
import Table from "../../../components/common/Table";
import Toaster from "../../../components/common/Toaster";
import referralService from "./../../../services/referralService";
import moment from "moment";

const Referrals = () => {
  const [referrals, setReferrals] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [tableOptions, setTableOptions] = useState({
    search_query: "",
    current_page: 1,
    page_size: 10,
    sort_column: { path: "created_on", order: "desc" },
  });

  const columns = [
    { path: "referral_code", label: "Code" },
    { path: "referrer_name", label: "Referrer" },
    { path: "account_name", label: "Referral" },
    { path: "created_on", label: "Date Created" },
  ];

  const fetchReferrals = useCallback(
    async (mounted) => {
      try {
        setIsLoading(true);

        const { result } = await referralService.getReferralsASync(
          tableOptions
        );

        if (mounted) {
          const data = result.map((item) => {
            item["referrer_name"] = item.referrer_name ?? "-";
            item["created_on"] = moment(item.created_on).format("LL");

            return item;
          });

          setReferrals(data);
          setIsLoading(false);
        }
      } catch (ex) {
        Toaster.Error("Something went wrong.");
        setIsLoading(false);
      }
    },
    [tableOptions]
  );

  useEffect(() => {
    let mounted = true;

    fetchReferrals(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchReferrals]);

  const handleSort = (sort_column) => {
    const options = { ...tableOptions };
    options.sort_column = sort_column;
    setTableOptions(options);
  };

  return (
    <div className="card">
      <div className="mb-5">
        <p className="text-gray-500">
          Account Referrals <span className="text-gray-400">— Last 10</span>
        </p>
      </div>
      <Table
        data={referrals}
        columns={columns}
        sortColumn={tableOptions.sort_column}
        onSort={handleSort}
        isLoading={isLoading}
      />
      <div className="flex flex-row-reverse">
        <Link to="referrals" className="text-blue-400 text-sm">
          View All Referrals
        </Link>
      </div>
    </div>
  );
};

export default Referrals;
